import { TEAM_MANAGER } from 'constants/roles';
import { UserTeam } from 'contexts/teams/types';

export interface IGenericUsersTableProps {
  accountPage?: boolean;
  refreshData?(): void;
}

export interface ITableColumn {
  name: string;
  subcolumns: string[];
  tooltip?: string;
  columnKey?: string;
}

export interface IUsersTableConfig {
  rowTableConfig: string;
  columns: ITableColumn[];
}

const ACTIONS_COLUMN_WIDTH = '104px';

export const getUsersTableConfig = (
  staffUser: boolean,
  accountPage: boolean,
  filterActive: boolean
): IUsersTableConfig => {
  if (!staffUser) {
    return {
      rowTableConfig: `40px minmax(0, 3fr) minmax(0, 2.5fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) ${ACTIONS_COLUMN_WIDTH}`,
      columns: [
        { name: 'Users', subcolumns: null, columnKey: 'user_display' },
        { name: 'Teams', subcolumns: null, columnKey: 'teams' },
        { name: 'License', subcolumns: null, columnKey: 'license' },
        filterActive && { name: 'Skill Dive', subcolumns: null, columnKey: 'license_addons' },
        {
          name: filterActive ? 'Last login' : 'Invited',
          subcolumns: null,
          tooltip: "User's last login to the platform",
          columnKey: filterActive ? 'user__last_login' : 'invited_at',
        },
      ],
    };
  } else if (staffUser && !accountPage) {
    return {
      rowTableConfig: `40px minmax(0, 3fr) minmax(0, 1.5fr) minmax(0, 1fr) minmax(0, 1.8fr) minmax(0, 1fr) ${ACTIONS_COLUMN_WIDTH}`,
      columns: [
        { name: 'Users', subcolumns: null, columnKey: 'user_display' },
        { name: 'Account', subcolumns: null },
        { name: 'Owner', subcolumns: null },
        { name: 'Teams', subcolumns: null, columnKey: 'teams' },
        { name: 'License', subcolumns: ['Plan', 'Skill Dive'], columnKey: 'license' },
      ],
    };
  } else {
    return {
      rowTableConfig: `40px minmax(0, 3fr) minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1.2fr) minmax(0, 1fr) ${ACTIONS_COLUMN_WIDTH}`,
      columns: [
        { name: 'Users', subcolumns: null, columnKey: 'user_display' },
        { name: 'Owner', subcolumns: null },
        { name: 'Teams', subcolumns: null, columnKey: 'teams' },
        { name: 'License', subcolumns: ['Plan', 'Skill Dive'], columnKey: 'license' },
        {
          name: filterActive ? 'Last login' : 'Invited',
          subcolumns: null,
          tooltip: "User's last login to the platform",
          columnKey: filterActive ? 'user__last_login' : 'invited_at',
        },
      ],
    };
  }
};

export const isRoleManager = (role: string, teams: UserTeam[]): boolean => {
  return role === TEAM_MANAGER && Boolean(teams.length > 0);
};
